import { useStyletron } from 'baseui';

import PasswordTipsList from 'components/UI/ENGTPassword/PasswordTipsList';

import { IObjProps } from 'shared/consts/types';
import { getPasswordRules } from 'shared/helpers';

function PasswordWidget({ value, wrapperCss }: { value: string; wrapperCss?: IObjProps }) {
	const [css, theme] = useStyletron();
	const passwordRules = getPasswordRules(value);
	const isPasswordTooltipValid = !!value && passwordRules.isValidLength && passwordRules.hasNonSpaceCharacter;

	if (isPasswordTooltipValid) {
		return null;
	}

	const wrapperCssObj: any = {
		borderTopWidth: '1px',
		borderTopStyle: 'solid',
		borderTopColor: theme.colors.accent100,
		borderLeftWidth: '1px',
		borderLeftStyle: 'solid',
		borderLeftColor: theme.colors.accent100,
		borderRightWidth: '1px',
		borderRightStyle: 'solid',
		borderRightColor: theme.colors.accent100,
		borderBottomWidth: '1px',
		borderBottomStyle: 'solid',
		borderBottomColor: theme.colors.accent100,
		borderRadiusBottom: '0.5rem',
		backgroundColor: theme.colors.primaryB,
		marginBottom: '1rem',
		boxSizing: 'border-box',
		maxWidth: '18rem',
		paddingTop: '0.75rem',
		paddingLeft: '0.875rem',
		paddingRight: '0.875rem',
		paddingBottom: '0.5rem',
		borderBottomRightRadius: '0.5rem',
		borderBottomLeftRadius: '0.5rem',
		...wrapperCss,
	};

	return (
		<div className={css(wrapperCssObj)}>
			<PasswordTipsList value={value} />
		</div>
	);
}

PasswordWidget.defaultProps = {
	wrapperCss: undefined,
};

export default PasswordWidget;
